import { render, staticRenderFns } from "./match.vue?vue&type=template&id=27542f62&"
import script from "./match.vue?vue&type=script&lang=js&"
export * from "./match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventCountdown: require('/var/web/bet777.es/components/event/countdown.vue').default,ElementsImgVideo: require('/var/web/bet777.es/components/elements/img_video.vue').default})
